import { directSupabase } from '../../../lib/supabaseClient';
import type { DooTableName } from '../types';

/** Typed table handle over the live `doo_*` schema. */
export function dooTable(table: DooTableName) {
  return directSupabase.from(table as never);
}
